import { render, staticRenderFns } from "./DimensionIssuedItemsView.vue?vue&type=template&id=72f9168d"
import script from "./DimensionIssuedItemsView.vue?vue&type=script&lang=js"
export * from "./DimensionIssuedItemsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports